import { HttpUtilsService } from './../../crud/utils/http-utils.service';
import { environment } from './../../../../../environments/environment';
// Angular
import { Injectable } from '@angular/core';
// RxJS
import { Subject, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MenuConfig } from '../../../../core/_config/custom/menu.config';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';


const API_ROOT_URL = environment.ApiRoot+"/UserNFC";

@Injectable()
export class MenuConfigService {
	// Public properties
	public configModel: MenuConfig = new MenuConfig();
	public onMenuUpdated$: BehaviorSubject<MenuConfig> = new BehaviorSubject(
		this.configModel
	);
	onConfigUpdated$: BehaviorSubject<MenuConfig>;

	// Private properties
	private menuConfig: any;
	menuHasChanged: any = false;
	/**
	 * Service Constructor
	 */
	constructor(private router: Router,private httpUtils: HttpUtilsService,private http: HttpClient) {
		// register on config changed event and set default config
		this.onConfigUpdated$ = new BehaviorSubject<MenuConfig>(this.configModel);
		this.router.events
			.pipe(filter(event => event instanceof NavigationStart))
			.subscribe(event => {
				if (this.menuHasChanged) {
					this.resetModel();
				}
			});
	}

	setModel(menuModel: MenuConfig) {
		this.configModel = Object.assign(this.configModel, menuModel);
		this.onMenuUpdated$.next(this.configModel);
		this.menuHasChanged = true;
	}

	resetModel() {
		this.configModel = new MenuConfig();
		this.onMenuUpdated$.next(this.configModel);
		this.menuHasChanged = false;
	}

	/**
	 * Returns the menuConfig
	 */
	getMenus() {
		return this.configModel.defaults;
	}

	setMenus(menuConfig: any){
		this.menuConfig = menuConfig;
		this.onConfigUpdated$.next(menuConfig);
	}

	/**
	 * Load config
	 *
	 * @param config: any
	 */
	loadConfigs(config: any) {
		this.menuConfig = config;
		this.onConfigUpdated$.next(this.menuConfig);
	}

	GetMenuPhanQuyen(_menu_config: any[] = []){
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const _config = {
			_menu_ids : _menu_config
		}
        return this.http.post<any>(API_ROOT_URL + '/GetMenuPhanQuyen', _config, { headers: httpHeaders });
	}
}
